export default {
    "title": "Food Forest Generator",
    "back_to_parent": "Back to Complex Earth",
    "routes": {
        "home": "Home",
        "patches": "Explore Sample Designs",
    },
    "home": {
        "lead": "Food Forest Generator automates the design of Food Forests—perennial self-supporting polycultural food systems suited to urban green space and community managed gardens.",
        "body":
          "<p>The user/s define a location anywhere in the world. The generator automatically creates a digital terrain of the location, selects plants from a global database of edible plants and matches them to the local climatic and geographical conditions (frost zone, soil pH, annual rainfall, and many other factors).</p>" +
          "<p>The generator uses advanced computation to place the selected plants on the digital terrain and optimises their positions in relation to buildings, other existing features, and each other. The generator creates the most productive Food Forest design possible for the site while simultaneously meeting the dietary and ecological preferences of the users, and the needs of the plants themselves.</p>" +
          "<p>This prototype version generates a 3D model, purchasing lists, and scale plans, providing the users with tools to implement and manage the virtual Food Forest in real life.</p>" +
          "<p>Click below to explore sample designs created by the Food Forest Generator!</p>"
    },
    "patches": {
        "headline": "Explore Sample Designs",
        "no_description": "No description has been provided for this design.",
        "visit": "Load this design"
    },
    "patch": {
        "exit": "Exit the Model",
        "camera": "Re-center model",
        "showAllInstances": "Highlight all {n} instances",
        "details": "Details",
        "no_data": "No result data has been found for this patch!",
        "filterClear": "Show all",
        "layer": {
            "label": "Layers",
            "0": "Tall trees",
            "1": "Small trees / large shrubs",
            "2": "Shrubs",
            "3": "Herbs and Vegetables",
            "4": "Ground cover"
        },
        "crop": {
            "label": "Crop filters",
            "fruit": "Fruit",
            "nut": "Nuts",
            "berry": "Berry",
            "salad": "Salad",
            "vegetable": "Vegetables",
            "drink": "Drink",
            "herb": "Herb",
            "rope": "Rope"
        },
        "system": {
            "label": "System filters",
            "bees": "Bee plant",
            "accumulator": "Mineral accumulator",
            "nitrogen": "Nitrogen fixer"
        },
        "plant": {
            "wikipedia": "Look up on Wikipedia",
            "no_description": "This plant has no description.",
            "usage": "Usage",
            "layer": "Layer",
            "frost": "Frost hardiness",
            "frost_explanation": "1 = Arctic, 13 = Tropical",
            "sun": {
                "label": "Sun preference",
                "shade": "Full shade",
                "semi": "Semi shade",
                "sun": "Full sun"
            },
            "systems": "Systems"
        },
        "tabs": {
            "patch": "Patch",
            "plant": "Plant"
        }
    },
    "submit": {
        "authkey": "AUTHENTICATION KEY",
        "description": "Description",
        "density": "Density",
        "crop_tags": "Crop choices",
        "frost_zone": "Frost zone (1=arctic, 13=tropical)",
        "is_bees": "Bees and insects",
        "is_native": "Native species",
        "name": "Name",
        "rainfall_annual": "Annual rainfall (in mm/m^2)",
        "soil_ph": "Soil pH",
        "soil_type": {
            "label": "Soil type",
            "light": "Light",
            "medium": "Medium",
            "heavy": "Heavy"
        },
        "terrain": "Terrain data",
        "submit": "Submit"
    },
    "page_not_found": {
        "body": "Sorry, this page does not exist.",
        "return": "Return to Home"
    },
};
